import {
    checkSkuUrl,
    addApplyProductUrl
} from 'Utils/urlUtil'
import { post, get } from 'Utils/apiUtil'

export const CHECK_SKU = "CHECK_SKU"
export const APPLY_PRODUCT = "APPLY_PRODUCT"

export function checkSku (params) {
    return dispatch => dispatch(get(`${checkSkuUrl}?scId=${params.scId}&sku=${params.sku}`)).then((res) => {
        dispatch({ type: CHECK_SKU, payload: res });
        return res
    });
}


export const addApplyProduct = data => dispatch => dispatch(post(addApplyProductUrl, data))
    .then(res => {
        dispatch({ type: APPLY_PRODUCT, payload: res });
        return res;
});